// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KpW0","colMin":"styles_colMin__3kAy_"};